module.exports = __webpack_public_path__ + "img/sc_back_transparent.66a25991.png";